export const lang = {
  en: {
    search: "Ask GPT",
    gptSearchPlaceholder: "Find your mood — try: Music+Animation",
    simpleSearchPlaceholder: "Search movie by name",
  },
  hin: {
    search: "GPT से पूछें",
    gptSearchPlaceholder: "जो देखना है वही पाएं — कोशिश करें: Music+Animation",
    simpleSearchPlaceholder: "नाम से मूवी खोजें",
  },
  guj: {
    search: "GPT ને પૂછો",
    gptSearchPlaceholder:
      "તમને શું જોવા નું મન છે? જરા આજમાવો: Music+Animation",
    simpleSearchPlaceholder: "નામ દ્વારા મૂવી શોધો",
  },
};
